export type Addresses = {
  [chainId: string]: Contracts;
};

export type Contracts = Partial<{
  [contractName in ContractName]: string;
}>;

export enum ContractName {
  USDC = "USDC",
  BatchQuery = "BatchQuery",
  CustomXSwapRouter = "CustomXSwapRouter",
  FeeCollector = "FeeCollector",
  StakingCosmicCadets = "StakingCosmicCadets",
  StakingSolarDivision = "StakingSolarDivision",
  StakingIntergalacticCommand = "StakingIntergalacticCommand",
  XSwapRouter = "XSwapRouter",
  XSwapToken = "XSwapToken",
  XSwapRouterSingleChain = "XSwapRouterSingleChain",
}
